import { render } from "./social-21.vue?vue&type=template&id=f2fd7372&scoped=true"
import script from "./social-21.vue?vue&type=script&lang=js"
export * from "./social-21.vue?vue&type=script&lang=js"

import "./social-21.vue?vue&type=style&index=0&id=f2fd7372&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2fd7372"]])

export default __exports__